module.exports = __webpack_public_path__ + "media/images/bank_images/hsbc-403a1daeed61075d5dd50e4cbaf16757.png";